import { TranslationKey } from '../../../types/i18next';

export const SUBSCRIPTION_PAID_FEATURES: {
  text: TranslationKey;
  extraText?: TranslationKey;
}[] = [
  {
    text: 'payment.subscriptionFeatures.aiAssistant.text'
  },
  {
    text: 'payment.subscriptionFeatures.aiCandidate.text'
  },
  {
    text: 'payment.subscriptionFeatures.aiImmigration.text',
    extraText: 'common.comingSoon'
  }
];

export const JOB_SUBSCRIPTION_MONTHLY_PRICE = 29;
